export default {
  ADMIN: "Status Page Admin",
  SUPER_USER: "Status Page Super User",
  SUPPORTED_USER: "Status Page Supported User",
  USER: "Status Page User"
};
